import { useMutation } from "@tanstack/react-query";
import { GET_DISTRIBUIDORAS } from "../query/constants";
import { getDistribuidoras, PlanOption } from "../services/onboarding";
import { useContext } from "react";
import { SessionContext } from "../context/session";

export function useGetDistribuidora() {
  const { setItemSession, getItemSession } = useContext(SessionContext);

  const distribuidora = getItemSession("distribuidora");
  const plan = getItemSession("plan");

  const pegarDistribuidora = useMutation({
    mutationFn: getDistribuidoras,
    mutationKey: [GET_DISTRIBUIDORAS],
    onSuccess: (data) => {
      const filterDistribuidora = data.find((item) => item.id === distribuidora);
      if (plan && filterDistribuidora) {
        const planData = JSON.parse(plan) as PlanOption;
        filterDistribuidora.descontoPadrao = planData.desconto / 100;
      }
      setItemSession("dados-distribuidora", JSON.stringify(filterDistribuidora));
    },
  });
  return pegarDistribuidora;
}
